import { useState } from 'react';
import { copy } from '../content/copy';
import { LButton } from '../components/LButton';
import { LInput } from '../components/LInput';
import { postLead } from '../../lib/leads';
import { reachGoal } from '../../lib/metrika';
import { SectionLabel } from '../components/SectionLabel';

export function ContactForm() {
  const { contact } = copy;
  const [form, setForm] = useState({ name: '', contact: '', grade: '' });
  const [consent, setConsent] = useState(false);
  const [state, setState] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  function update<K extends keyof typeof form>(key: K, value: string) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!consent) return;
    setState('submitting');
    const r = await postLead(form);
    if (r.ok) {
      setState('success');
      reachGoal('form_submit');
      setForm({ name: '', contact: '', grade: '' });
    } else {
      setState('error');
      setErrorMsg(contact.errorGeneric);
    }
  }

  return (
    <section id="contact" className="bg-l-paper px-6 md:px-10 py-20 md:py-28">
      <div className="mx-auto max-w-[820px]">
        <SectionLabel>РАЗДЕЛ 07 · ЗАПИСЬ</SectionLabel>
        <h2 className="font-display font-medium text-l-ink-deep text-[32px] md:text-[42px] leading-[1.15] tracking-[-0.02em] mb-4">
          {contact.title}
        </h2>
        <p className="font-sans text-l-ink-muted text-[17px] mb-10">{contact.subtitle}</p>

        {state === 'success' ? (
          <div className="bg-l-paper-soft border border-l-rule rounded-xl p-8">
            <h3 className="font-display text-l-ink-deep text-2xl mb-2">{contact.successTitle}</h3>
            <p className="font-sans text-l-ink">{contact.successBody}</p>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="flex flex-col gap-4">
            <LInput
              placeholder={contact.fields.name}
              value={form.name}
              onChange={(e) => update('name', e.target.value)}
              required
              minLength={2}
              maxLength={100}
              autoComplete="name"
            />
            <LInput
              placeholder={contact.fields.contact}
              value={form.contact}
              onChange={(e) => update('contact', e.target.value)}
              required
              minLength={3}
              maxLength={200}
            />
            <LInput
              placeholder={contact.fields.grade}
              value={form.grade}
              onChange={(e) => update('grade', e.target.value)}
              required
              minLength={1}
              maxLength={20}
            />

            <label className="flex items-start gap-3 mt-2 cursor-pointer">
              <input
                type="checkbox"
                checked={consent}
                onChange={(e) => setConsent(e.target.checked)}
                required
                className="mt-1 accent-l-terracotta"
              />
              <span className="font-sans text-l-ink-muted text-[14px] leading-[1.5]">
                {contact.consent}{' '}
                <a href={contact.consentHref} className="text-l-terracotta underline underline-offset-2" target="_blank" rel="noreferrer">
                  {contact.consentLink}
                </a>.
              </span>
            </label>

            <LButton
              type="submit"
              disabled={!consent || state === 'submitting'}
              className="mt-4 w-full md:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {state === 'submitting' ? '...' : contact.submit}
            </LButton>

            {state === 'error' && (
              <p className="font-sans text-l-terracotta text-sm">{errorMsg}</p>
            )}
          </form>
        )}

        <div className="mt-10 pt-8 border-t border-l-rule flex flex-col sm:flex-row gap-4 sm:gap-8 font-sans text-l-ink-muted text-[15px]">
          <a href={contact.alt.telegram.href} className="hover:text-l-terracotta">
            {contact.alt.telegram.label}
          </a>
          <a href={contact.alt.vk.href} className="hover:text-l-terracotta">
            {contact.alt.vk.label}
          </a>
          <a href={contact.alt.email.href} className="hover:text-l-terracotta">
            {contact.alt.email.label}
          </a>
        </div>
      </div>
    </section>
  );
}
